import React from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { CanyonRecord, WaterLevel } from "../types/CanyonRecord";
import { apiFetch } from "../utils/api";
import RecordEditor from "../components/records/RecordEditor";
import PageTemplate from "./PageTemplate";
import { useTranslation } from 'react-i18next';

const EditRecordPage: React.FC = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { id } = useParams<{ id?: string }>();
    const recordIdNum = id ? parseInt(id, 10) : undefined;

    const [isRecordLoading, setRecordLoading] = useState(false);
    const [initialValues, setInitialValues] = useState<CanyonRecord>();

    useEffect(() => {

        if (!recordIdNum) {
            navigate('/record');
        };

        setRecordLoading(true);
        apiFetch<CanyonRecord>('/api/record/' + recordIdNum)
            .then(data => {
                console.log(data)
                setInitialValues({
                    Id: data.Id,
                    Date: data.Date.split('T')[0],
                    TeamSize: data.TeamSize,
                    Comments: data.Comments || '',
                    RopeIds: data.RopeIds,
                    GearIds: data.GearIds,
                    Tags: data.Tags,
                    CanyonId: data.CanyonId || undefined,
                    UserCanyonId: data.UserCanyonId || undefined,
                    WaterLevel: data.WaterLevel || WaterLevel.Unknown,
                    TripRating: data.TripRating || undefined,
                });
            })
            .finally(() => setRecordLoading(false));
    }, [recordIdNum, navigate]);

    return <PageTemplate pageTitle={t('journal.editRecord')} isAuthRequired isLoading={isRecordLoading || !initialValues}>
        <RecordEditor initialValues={initialValues} submitString={t('journal.saveChanges')} isEdit />
    </PageTemplate>
}

export default EditRecordPage;
